class IsPostContentHidden {
  execute(post) {
    var _a;
    return (post === null || post === void 0 ? void 0 : post.roleType) === 'creator' ? false : (post === null || post === void 0 ? void 0 : post.roleType) === 'not-member' ? true : Boolean((post === null || post === void 0 ? void 0 : post.releaseAt) && new Date((_a = post === null || post === void 0 ? void 0 : post.releaseAt) !== null && _a !== void 0 ? _a : 0) > new Date());
  }
}

export { IsPostContentHidden };
